// extracted by mini-css-extract-plugin
export var button = "_mz-0";